import React, { useState } from 'react';
import Container from '../Container/Container';
// import Button from '../Button/Button';
import s from './SearchNewProducts.module.css';
import * as API from '../../services/API/back_end';
// import Ribbon from '../Ribbon/Ribbon';

export default function SearchNewProducts() {
  const inverted = false;
  const [email, setEmail] = useState('');

  const onChange = e => {
    setEmail(e.target.value);
  };

  const onSubmit = e => {
    e.preventDefault();
    const data = JSON.stringify({ email });
    API.setForm(data).catch(console.log('ВСЕ ПРОПВЛО!!!'));
    setEmail('');
  };

  return (
    <section className={s.wrapper}>
      <Container>
        <h2 className={s.title}>Дізнайся першим про новинки</h2>
        <p className={s.description}>підпишись на розсилку</p>
        <form onSubmit={onSubmit} className={s.form}>
          <input
            onChange={onChange}
            value={email}
            className={s.input}
            type="email"
            name="emailSearchNewProduct"
            placeholder="Ваш e-mail"
          />

          <button
            name="Пiдписатися"
            type="submit"
            className={inverted ? s.buttonInverted : s.button}
          >
            Пiдписатися
          </button>
        </form>
      </Container>
      {/* <Ribbon /> */}
    </section>
  );
}
